/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="76.61"
        height="95.58"
        viewBox="0 0 76.61 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M52 .66a1.25 1.25 0 0 1 2.26 1.06l-.06.12-20 37.4a1.253 1.253 0 0 1-2.27-1.06l.06-.12ZM74.25.66a1.25 1.25 0 0 1 2.27 1.05l-.06.13-22 41.24a1.25 1.25 0 0 1-2.27-1l.06-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M23.21.15a1.24 1.24 0 0 1 1.62.39l.08.12 14.54 27.21a1.252 1.252 0 0 1-2.14 1.3l-.07-.12L22.7 1.84a1.24 1.24 0 0 1 .51-1.69ZM.66.15a1.24 1.24 0 0 1 1.62.39l.07.12 22.06 41.25a1.25 1.25 0 0 1-2.13 1.3l-.07-.12L.15 1.84A1.24 1.24 0 0 1 .66.15Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M38.35 36.9a29.34 29.34 0 1 0 29.34 29.34A29.34 29.34 0 0 0 38.35 36.9Zm0 2.5a26.84 26.84 0 1 1-26.84 26.84A26.84 26.84 0 0 1 38.35 39.4Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M38.35 43.99A22.25 22.25 0 1 0 60.6 66.24a22.25 22.25 0 0 0-22.25-22.25Zm0 2.5A19.75 19.75 0 1 1 18.6 66.24 19.75 19.75 0 0 1 38.35 46.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m38.35 53.76 3.64 7.38 8.14 1.18-5.89 5.74 1.39 8.11-7.28-3.83-7.28 3.83 1.38-8.11-5.89-5.74 8.15-1.18 3.64-7.38z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m42.32 60.68-4-8.05-4 8.05-8.88 1.29 6.43 6.27-1.52 8.85 7.95-4.18 8 4.18-1.52-8.85 6.43-6.27Zm-7.32.91 3.31-6.7 3.31 6.7 7.4 1.08-5.32 5.22 1.3 7.37-6.62-3.48-6.62 3.48L33 67.89l-5.35-5.22Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'MedalWithStarIcon';

export default Icon;
